function jsonParseSafe(value) {
  try {
    return typeof value === "string" ? JSON.parse(value) : void 0;
  } catch {
    return void 0;
  }
}
const jsonParseOrUse = (value) => jsonParseSafe(value) ?? value;
export {
  jsonParseOrUse,
  jsonParseSafe
};
